module.exports = __webpack_public_path__ + "static/media/fresh-factory-img8.3f0e40b1.png";